export default __webpack_public_path__ + "a4cde8805d14dd508ab67b1529aa3afc.png";